module.exports = __webpack_public_path__ + "img/zhuxiaoyao.284629e4.jpg";